import { useQuery } from "@tanstack/react-query";

import { useUserStore } from "base/stores";

import { AdminQuery } from "./admin.service.js";

export function useUserExistInAllSandboxes(queryConfig = {}) {
  const currentUserId = useUserStore.getState().currentUser._id;

  return useQuery({
    queryKey: AdminQuery.checkUserExistIAllSandboxesKey({
      userId: currentUserId
    }),
    queryFn: () =>
      AdminQuery.checkUserExistInAllSandboxes({
        userId: currentUserId
      }),
    staleTime: 1000 * 60, // 1 minute
    ...queryConfig
  });
}

export const checkUserExistInAllSandboxesKey =
  AdminQuery.checkUserExistIAllSandboxesKey;
